import { defineComponent } from "vue";
import LogoClinicarx from "@/assets/themes/clinicarx-logo-green.svg";

export default defineComponent({
  props: {
    name: String,
  },
  data() {
    return {
      logoPath: LogoClinicarx,
    };
  },
});
